import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@base-ui/react/dialog';
import { css } from '@repo/pandacss/css';
import { AnalyticsFeatureViewed } from '@repo/platform-analytics/AnalyticsFeatureViewed';
import { Content } from './Content';
import { CTAs } from './CTAs';
import { Header } from './Header';
const ANALYTICS_ENTITY_NAME = 'exit_intent_modal';
export function ExitModal(t0) {
  const $ = _c(11);
  const {
    featureViewedActivityId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Dialog.Backdrop className={css({
      position: "fixed",
      inset: "[0]",
      bg: "[rgba(0,0,0,0.5)]",
      zIndex: "[1000]"
    })} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = css({
      position: "fixed",
      inset: "[0]",
      zIndex: "[1001]",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      p: "4"
    });
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css({
      bg: "common.white",
      py: {
        base: "5",
        sm: "5",
        lg: "6"
      },
      px: {
        base: "3",
        sm: "5",
        lg: "6"
      },
      width: "[100%]",
      maxWidth: "[650px]"
    });
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = css({
      display: "flex",
      flexDirection: "column",
      gap: {
        base: "3",
        lg: "4"
      }
    });
    t5 = <Header />;
    t6 = <Content />;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t4 = $[3];
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== featureViewedActivityId) {
    t7 = <div className={t4}>{t5}{t6}<CTAs parentActivityId={featureViewedActivityId} /></div>;
    $[6] = featureViewedActivityId;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== featureViewedActivityId || $[9] !== t7) {
    t8 = <Dialog.Portal>{t1}<Dialog.Viewport className={t2}><Dialog.Popup className={t3}><AnalyticsFeatureViewed activityId={featureViewedActivityId} entityName={ANALYTICS_ENTITY_NAME} entitySection="cardfinder_flow">{t7}</AnalyticsFeatureViewed></Dialog.Popup></Dialog.Viewport></Dialog.Portal>;
    $[8] = featureViewedActivityId;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
}